import script from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=28a86a81&scoped=true&lang=css"

import exportComponent from "/Users/fish/Development/product-engine-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a86a81"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QForm,QInput,QIcon,QBtn});
